import { Component, OnInit, Output,EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-next-phase',
  templateUrl: './next-phase.component.html',
  styleUrls: ['./next-phase.component.scss']
})
export class NextPhaseComponent implements OnInit {
@Output() isNextPhaseModalVisible=new EventEmitter<boolean>();
@Input() documentPhase!: number;
  constructor() { }
  

  ngOnInit(): void {
  }

  documentNextPhase(){
    this.isNextPhaseModalVisible.emit(true);
  }

}
